export { P160ArticlePage as default } from './components/P160ArticlePage';
